export function getData(business, config) {
  const businessTypeId = business.businessTypeId;
  let data = [];
  if (businessTypeId === 1) {
    const pack = (config.packages || []).filter(
      (item) => item.id === business.packageId
    );
    if (pack.length > 0) {
      data.push({
        name: pack[0].name,
        price: pack[0].price,
      });
    }
    const selectedLicenseReport = (config?.licenseReport || []).find(
      (item) => item.id === business.licenseReportId
    );
    if (selectedLicenseReport) {
      data.push({
        name: selectedLicenseReport.name,
        price: selectedLicenseReport.price,
      });
    }

    const expeditedProcess = config?.expeditedProcess || [];
    const foundersKit = config?.foundersKit || [];

    // Check if config is defined and businessTypeId is 1
    if (
      businessTypeId === 1 &&
      business.expeditedProcessId !== undefined &&
      expeditedProcess.length > 0 &&
      expeditedProcess[0]?.name &&
      expeditedProcess[0]?.price
    ) {
      data.push({
        name: expeditedProcess[0].name,
        price: expeditedProcess[0].price,
      });
    }
    
    if (
      businessTypeId === 1 &&
      business.foundersKitId !== undefined &&
      foundersKit.length > 0 &&
      foundersKit[0]?.name !== undefined &&
      foundersKit[0]?.price !== undefined
    ) {
      data.push({
        name: foundersKit[0].name,
        price: foundersKit[0].price,
      });
    }
  } else {
    const corpoPack = (config.scorp || []).filter(
      (item) => item.id === business.scorpId
    );
    if (corpoPack.length > 0) {
      data.push({
        name: corpoPack[0].name,
        price: corpoPack[0].price,
      });
    }

    const tax = (config.taxExperts || []).filter(
      (item) => item.id === business.taxExpertsId
    );
    if (tax.length > 0) {
      data.push({
        name: tax[0].name,
      });
    }
  }
  const operationAgreement = (config.operationAgreement || []).filter(
    (item) => item.id === business.operationAgreementId
  );
  if (operationAgreement.length > 0) {
    data.push({
      name: operationAgreement[0].name,
      price: operationAgreement[0].price,
    });
  }
  return data;
}
